<template>
  <div>
    <div class="title">
      {{ $t('settings.department.threshold.threshold') }}
    </div>
    <div class="hr" />
    <div class="container">
      <span class="lable">{{ $t('settings.department.threshold.thresholdValue') }}</span>
      <InputField
        v-hkldinput
        :autoTrim="true"
        :showFlag="true"
        :showColon="false"
        :showEmptyDash="true"
        :hideLabel="true"
        :required="true"
        :readonlyAsInput="allowEdit"
        :value="value"
        inputCheckType="integer"
        :inputTip="inputTip"
        :pattern="/^\d{1,11}$/"
        :dirtyCheck="true"
        @updateValue="updateValue"
        :extendClass="'department-threshold'"
      />
    </div>
  </div>
</template>
<script>
import currencyFormatter from 'currency-formatter'
import InputField from '@/controls/InputField'

export default {
  name: 'Threshold',
  components: {
    InputField,
  },
  model: {
    prop: 'data',
    event: 'onChange',
  },
  props: {
    formOptions: Object,
    data: Object,
  },
  data () {
    return {
      inputTip: this.$t('settings.threshold.hint', [1, 11]),
    }
  },
  computed: {
    allowEdit () {
      const { formOptions: options } = this
      return options.readonly ||
        !(options.isAdmin || options.hasSettingUpdateAccess || options.hasThresholdUpdateAccess)
    },
    value () {
      const value = this.data.tenderAmountThreshold || 0
      if (this.formOptions.readonly) {
        return currencyFormatter.format(value, 'USD')
      }
      return value
    },
  },
  methods: {
    updateValue (val) {
      this.data.tenderAmountThreshold = val
    },
  },
}
</script>
<style scoped lang="scss">
.title {
  color: #0C3A58;
  font-weight: bold;
}
.hr {
  margin-bottom: 10px;
  margin-top: 10px;
  width: 100%;
  height: 1px;
  border-bottom: 1px solid #acacac;
}
.container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .lable {
    flex-basis: 350px;
    line-height: 40px;
  }
}
</style>
